import { cloneElement, FC, useState } from 'react';
import { Box, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import RightArrowIcon from '../../../../../assets/icons/user-info/Right.png';
import CityAndAiroportForm from './components/CityAndAiroportForm';
import TravelFrom from './components/TravelFrom/TravelFrom';
import BudgetPreferences from './components/BudgetPreferences';
import PreferredPace from './components/PreferredPace';
import PrimaryTravelPurpose from './components/PrimaryTravelPurpose';
import Destinations from './components/Destinations';
import Interests from './components/Interests';
import { useAppSelector } from '../../../../../hooks/redux';

import styles from './Personalization.module.scss';

const Personalization: FC = () => {
  const [openModal, setOpenModal] = useState<string | null>(null);
  const user = useAppSelector((state) => state.user);

  const handleModalOpen = (title: string) => setOpenModal(title);
  const handleModalClose = () => setOpenModal(null);

  const personalizationList = [
    {
      title: 'Nearest City and Airport',
      subTitle: (user.nearest_city || user.nearest_airport) && [user.nearest_city, user.nearest_airport ].join(', '),
      component: <CityAndAiroportForm closeModal={handleModalClose}/>
    },
    {
      title: 'Travel style',
      subTitle: user.travel_preference && `${user.travel_preference} travel`,
      component: <TravelFrom closeModal={handleModalClose}/>
    },
    {
      title: 'Budget Preferences',
      subTitle: `${user.budget_preference}`,
      component: <BudgetPreferences closeModal={handleModalClose}/>
    },
    {
      title: 'Preferred Pace',
      subTitle: (user.pace_preference && user.trip_planning_style) ? [user.pace_preference, user.trip_planning_style ].join(', ') : user.pace_preference ? user.pace_preference : user.trip_planning_style,
      component: <PreferredPace closeModal={handleModalClose}/>
    },
    {
      title: 'Primary Travel Purpose',
      subTitle: user.primary_travel_purposes.join(', '),
      component: <PrimaryTravelPurpose closeModal={handleModalClose}/>
    },
    {
      title: 'Types Of Destinations',
      subTitle: user.destination_types.join(', '),
      component: <Destinations closeModal={handleModalClose} />
    },
    {
      title: 'Activity Interests',
      subTitle: user.activity_interests.join(', '),
      component: <Interests closeModal={handleModalClose} />
    },
  ]

  return (
    <Box className={styles.personalization}>
      <Typography variant='h7Bold'>Personalization</Typography>
      {personalizationList.map(item => (
        <Box key={item.title} className={styles.personalizationContent}>
          <Modal
            open={openModal === item.title}
            onClose={handleModalClose}
            aria-labelledby={item.title}
            aria-describedby={item.title}
            sx={{
              "& .MuiBackdrop-root": {
                backgroundColor: 'rgba(34, 43, 58, 0.2)'
              },
            }}
          >
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: 'fit-content',
              minWidth: 375,
              width: '100%',
              bgcolor: 'background.paper',
              borderRadius: "20px",
              p: '32px 64px',
              overflowY: 'auto',
              boxShadow: 'none',
              maxHeight: '90vh',
              '@media (max-width: 900px)': {
                p: '16px 32px',
              },
            }}>
              <Box sx={{ position: 'absolute', top: 16, right: 20, cursor: 'pointer' }}>
                <CloseIcon sx={{width: '30px', height: '30px'}} onClick={handleModalClose} />
              </Box>
                {cloneElement(item.component, { handleModalClose })}
            </Box>
          </Modal>

          <Box className={styles.personalizationBtnWrapper} onClick={() => handleModalOpen(item.title)}>
            <Box className={styles.personalizationBtnTextContent}>
              <Typography variant='h11Semibold'>{item.title}</Typography>
              <Typography variant='h11'>{item.subTitle}</Typography>
            </Box>

            <img src={RightArrowIcon} className={styles.personalizationBtnIcon} alt='right arrow' />
          </Box>
        </Box>
      ))}

    </Box>
  )
}

export default Personalization;
